import * as React from "react";
import * as ReactDOM from "react-dom";
import Loadable from 'react-loadable';
import LoadingIcon from './../../common/components/LoadingIcon';
const checklistSelector = ".react-control-checklist";

const LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: "checklist" */ './../../common/controls/Checklist/Checklist'),
	loading: LoadingIcon,
});

const renderChecklist = function (control) {
	return ReactDOM.render(
			<LoadableComponent
				issueId={control.dataset.issueId}
				issueType={control.dataset.issueType}
				lazy={false}
			/>,
		control);
};

export default {
	render: renderChecklist,
	selector: checklistSelector
} 